import { buildQueryParams } from '../apiHelpers';
import { _request,APIBaseResponse, APIMethod } from '../index';
import { PaginatedRequestParamsBase } from '../Models/CommonRequestModels';
import { UserTenantMembershipStatusProps } from '../TenantUserMembership/TenantUserMembershipApiTypeDefs';

const PROFILES_PREFIX = '/profiles';
const TENANTS_PATH_PREFIX = '/tenants';
const ROLE_USER_PATH_PREFIX = 'userrolememberships';

export type APIRoleUserMembershipGetPaginatedListParams = PaginatedRequestParamsBase & {
    tenantId: string;
    roleId: string;
    rowsCount?: number;
    retries?: number;
    status?: string[];
};

interface APIRoleUserMembershipGetPaginatedListResponse {
    data: IAPIRoleUserMembershipGetPaginatedSingleResponse[];
    skipped: number;
    taken: number;
    count: number;
    error: string | null;
    success: boolean;
}
export interface IUser {
    userId: string;
    oasysId?: string;
    profile: {
        firstName: string;
        lastName: string;
        principalName: string;
        companyKey: string;
        email: string;
    }
}

export type IAPIRoleUserMembershipGetPaginatedSingleResponse =
    IUser & UserTenantMembershipStatusProps & {
    roleId: string;
    value: string;
    status: string;
    startDate: string;
    endDate:string;
}

export const APIRoleUserMembershipGetPaginatedList: APIMethod<APIRoleUserMembershipGetPaginatedListParams, APIRoleUserMembershipGetPaginatedListResponse> = params => {
    const queryParams = buildQueryParams(params, [{ key : 'status' }]);
    const endPoint = `${PROFILES_PREFIX}${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLE_USER_PATH_PREFIX}`;
    const requestPath = `${endPoint}` + (queryParams && `?${queryParams}`);
    return _request('GET', requestPath, undefined, params.signal, params.retries);
};

type APIRoleUserMembershipDeleteParams = {
    tenantId: string;
    roleId: string;
    userId: string;
}

export const APIRoleUserMembershipDelete: APIMethod<APIRoleUserMembershipDeleteParams, APIBaseResponse> = params => {
    const queryParams = buildQueryParams(params);
    const endPoint = `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLE_USER_PATH_PREFIX}`;
    const requestPath = `${endPoint}` + (queryParams && `?${queryParams}`);
    return _request('DELETE', requestPath);
};

type APIRoleUserMembershipCreateParams = {
    tenantId: string;
    roleId: string;
    userId: string;
}

export const APIRoleUserMembershipPost: APIMethod<APIRoleUserMembershipCreateParams, APIBaseResponse> = params => {
    return _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLE_USER_PATH_PREFIX}`, {
        tenantId: params.tenantId,
        userId: params.userId,
        roleId: params.roleId,
    });
};
